import { render, staticRenderFns } from "./LegalCharges.vue?vue&type=template&id=a412df98"
import script from "./LegalCharges.vue?vue&type=script&lang=js"
export * from "./LegalCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports